/**
 * tocUtils — TipTap JSON 기반 목차(TOC) 추출 유틸
 *
 * heading 노드를 순회하여 목차 항목을 생성합니다.
 */

export interface TocItem {
  id: string;       // heading-0, heading-1, ...
  text: string;     // heading 텍스트
  level: number;    // 1 | 2 | 3
}

/**
 * TipTap JSON에서 heading 노드를 추출하여 TOC 항목 배열로 변환.
 * @param json TipTap getJSON() 결과 객체
 * @returns TocItem 배열 (비어있을 수 있음)
 */
export function extractTocFromJson(json: any): TocItem[] {
  if (!json || !json.content || !Array.isArray(json.content)) return [];

  const items: TocItem[] = [];
  let idx = 0;

  for (const node of json.content) {
    if (node.type === 'heading' && node.attrs?.level) {
      const text = extractTextFromNode(node);
      if (text.trim()) {
        items.push({
          id: `heading-${idx}`,
          text: text.trim(),
          level: node.attrs.level,
        });
        idx++;
      }
    }
  }

  return items;
}

/** 노드에서 텍스트를 재귀적으로 추출 */
function extractTextFromNode(node: any): string {
  if (node.type === 'text') return node.text ?? '';
  if (!node.content || !Array.isArray(node.content)) return '';
  return node.content.map(extractTextFromNode).join('');
}
